import { FC, ReactNode, useState } from 'react';
import { useGetCurrentUserQuery } from '@teachur/http-client';
import { ScheduledCall } from '@teachur/http-client';
import { CancelScheduledCallModal } from './CancelScheduledCallModal';

interface CancelScheduledCallActionProps {
  call: ScheduledCall;
  children: ReactNode;
}

export const CancelScheduledCallAction: FC<CancelScheduledCallActionProps> = ({
  call,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { data: currentUser } = useGetCurrentUserQuery();

  const isCurrentUserInstructor = currentUser?.id === call.instructorId;
  const mode = isCurrentUserInstructor ? 'instructor' : 'student';

  return (
    <>
      <span onClick={() => setIsOpen(true)}>{children}</span>

      <CancelScheduledCallModal
        callId={call.id}
        courseId={call.courseId}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        mode={mode}
      />
    </>
  );
};
